<input
  data-dd-action-name="gl-account-typeahead.account-input"
  #input
  type="text"
  appFormControl
  [(ngModel)]="model"
  [disabled]="disabled"
  [ngbTypeahead]="search"
  [editable]="false"
  [inputFormatter]="formatter"
  [resultFormatter]="formatter"
  [resultTemplate]="ResultTemplate"
  (focus)="focus$.next($any($event).target.value)"
  (click)="click$.next($any($event).target.value)"
  (blur)="onBlur()"
  (selectItem)="onSelect($event)"
/>

<ng-content></ng-content>

<ng-template
  #ResultTemplate
  let-result="result"
  let-format="formatter"
  let-term="term"
>
  <div [attr.data-account-type]="GlAccountTypeId[result.accountTypeId]">
    <ngb-highlight [result]="format(result)" [term]="term"></ngb-highlight>
  </div>
</ng-template>
